import React from "react";
import { connect } from "react-redux";
import * as actions from "../actions";
import CookiePopup from "../components/cookie/cookiePopup/cookiePopup";

export const parsePopup = (popup) => {
  if (!popup) return {};
  return {
    body: popup?.body,
    accept: popup?.accept,
    decline: popup?.dismiss,
  };
};

class CookieConsentHOC extends React.Component {
  state = {
    analyticsCheckbox: false,
  };

  setDismissedCookie = (analytics) => {
    this.props.cookieConsentAction({ analytics });
  };

  setAnalyticsCheckboxHandler = () => {
    this.setState({
      analyticsCheckbox: !this.state.analyticsCheckbox,
    });
  };

  render() {
    const { cookiesConsentAction, labelCheckBox } = this.props;
    const { analyticsCheckbox } = this.state;
    const popup = parsePopup(this.props.popup);
    return !cookiesConsentAction && popup ? (
      <CookiePopup
        handleChange={this.setDismissedCookie}
        body={popup.body}
        accept={popup.accept}
        decline={popup.decline}
        checkBoxText={labelCheckBox}
        handleCheckBox={this.setAnalyticsCheckboxHandler}
        checkBoxValue={analyticsCheckbox}
      />
    ) : null;
  }
}

const mapStateToProps = (state) => ({
  popup: state.cookies?.popup,
  expiryDays: state.cookies?.expiryDays,
  cookiesConsentAction: state.cookies?.cookiesConsentAction,
  cookiesEnabled: state.cookies?.cookiesEnabled || {},
  labelCheckBox: state.cookies?.labelCheckBox,
});

const mapDispatchToProps = (dispatch) => ({
  cookieConsentAction: (payload) => {
    dispatch(actions.cookieConsentAction(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CookieConsentHOC);
